import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyView: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-6">
          <Link to="/" className="text-indigo-400 hover:text-indigo-300 text-sm">
            ← ホームに戻る
          </Link>
        </div>
        
        <div className="bg-gray-800 rounded-lg p-6 md:p-8">
          <h1 className="text-3xl font-bold mb-8 text-indigo-400">AISHA プライバシーポリシー</h1>
          
          <p className="text-gray-300 mb-6">
            株式会社ツクルマ（以下「当社」といいます）は、AI車画像生成・グッズ作成サービス「AISHA」（以下「本サービス」といいます）における個人情報の取扱いについて、以下のとおりプライバシーポリシーを定めます。
          </p>

          <div className="prose prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">1. 個人情報の定義</h2>
              <p className="text-gray-300">
                「個人情報」とは、生存する個人に関する情報であって、当該情報により特定の個人を識別できるもの、または他の情報と容易に照合することができ、それにより特定の個人を識別することができるものをいいます。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">2. 収集する情報</h2>
              <p className="mb-3 text-gray-300">当社は、本サービスの提供にあたり、以下の情報を収集します：</p>
              
              <h3 className="text-lg font-semibold mb-2 text-gray-200">2.1 アカウント情報</h3>
              <ul className="list-disc list-inside space-y-1 text-gray-300 mb-4">
                <li>メールアドレス（MyGarageアカウント利用時）</li>
                <li>電話番号（電話番号認証利用時）</li>
                <li>ユーザー名</li>
              </ul>

              <h3 className="text-lg font-semibold mb-2 text-gray-200">2.2 配送情報</h3>
              <ul className="list-disc list-inside space-y-1 text-gray-300 mb-4">
                <li>氏名</li>
                <li>配送先住所</li>
                <li>郵便番号</li>
                <li>電話番号</li>
              </ul>

              <h3 className="text-lg font-semibold mb-2 text-gray-200">2.3 サービス利用情報</h3>
              <ul className="list-disc list-inside space-y-1 text-gray-300">
                <li>愛車写真</li>
                <li>生成画像データ</li>
                <li>グッズ購入履歴</li>
                <li>アクセスログ</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">3. クレジットカード情報の取扱い</h2>
              <div className="bg-indigo-900/30 border border-indigo-700 rounded-lg p-4 mb-4">
                <p className="text-gray-200 font-semibold">
                  クレジットカード情報は、決済代行会社であるStripe社によって厳重に管理され、当社では一切の情報を保有いたしません。
                </p>
              </div>
              <p className="text-gray-300">
                決済処理は全てStripe社の安全なシステムを通じて行われ、当社のサーバーを経由することはありません。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">4. 個人情報の利用目的</h2>
              <p className="mb-3 text-gray-300">収集した個人情報は、以下の目的でのみ利用します：</p>

              <h3 className="text-lg font-semibold mb-2 text-gray-200">4.1 サービス提供</h3>
              <ul className="list-disc list-inside space-y-1 text-gray-300 mb-4">
                <li>本サービスの提供、運営、維持管理</li>
                <li>グッズの製造、配送手配</li>
                <li>ユーザーサポート対応</li>
              </ul>

              <h3 className="text-lg font-semibold mb-2 text-gray-200">4.2 配送先情報の利用制限</h3>
              <div className="bg-indigo-900/30 border border-indigo-700 rounded-lg p-4 mb-4">
                <p className="text-gray-200 font-semibold">
                  ユーザーが発送先情報として登録した情報は、グッズの配送目的以外での利用は一切いたしません。
                </p>
              </div>

              <h3 className="text-lg font-semibold mb-2 text-gray-200">4.3 サービス改善</h3>
              <ul className="list-disc list-inside space-y-1 text-gray-300 mb-4">
                <li>サービス品質の向上</li>
                <li>新機能の開発</li>
                <li>統計データの作成（個人を特定できない形式）</li>
              </ul>

              <h3 className="text-lg font-semibold mb-2 text-gray-200">4.4 連絡</h3>
              <ul className="list-disc list-inside space-y-1 text-gray-300">
                <li>重要なお知らせの通知</li>
                <li>お問い合わせへの返信</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">5. 個人情報の第三者提供</h2>
              <p className="mb-3 text-gray-300">当社は、以下の場合を除き、個人情報を第三者に提供することはありません：</p>

              <h3 className="text-lg font-semibold mb-2 text-gray-200">5.1 グッズ製造・配送のための提供</h3>
              <ul className="list-disc list-inside space-y-1 text-gray-300 mb-4">
                <li>Printfulへの必要最小限の情報提供（配送先情報等）</li>
                <li>これらの提携先は、提供された情報を配送目的以外で使用しません</li>
              </ul>

              <h3 className="text-lg font-semibold mb-2 text-gray-200">5.2 法令に基づく場合</h3>
              <ul className="list-disc list-inside space-y-1 text-gray-300 mb-4">
                <li>法令により開示が求められる場合</li>
                <li>人の生命、身体または財産の保護のために必要な場合</li>
                <li>公衆衛生・児童の健全育成に特に必要な場合</li>
              </ul>

              <h3 className="text-lg font-semibold mb-2 text-gray-200">5.3 ユーザーの同意がある場合</h3>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">6. 個人情報の安全管理</h2>
              <p className="mb-3 text-gray-300">当社は、個人情報の漏洩、滅失または毀損の防止その他の安全管理のために、以下の措置を講じます：</p>
              <ul className="list-disc list-inside space-y-1 text-gray-300">
                <li>SSL/TLS暗号化通信の使用</li>
                <li>アクセス権限の適切な管理</li>
                <li>定期的なセキュリティ監査</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">7. Cookieの使用</h2>
              <p className="text-gray-300">
                本サービスでは、サービス品質向上のためCookieを使用することがあります。Cookieは個人を特定する情報を含みません。ブラウザの設定によりCookieを無効にすることも可能ですが、一部のサービスが利用できなくなる場合があります。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">8. 外部サービスとの連携</h2>
              
              <h3 className="text-lg font-semibold mb-2 text-gray-200">8.1 MyGarage</h3>
              <p className="text-gray-300 mb-4">MyGarageアカウントでログインする場合、MyGarageのプライバシーポリシーも適用されます。</p>

              <h3 className="text-lg font-semibold mb-2 text-gray-200">8.2 決済サービス（Stripe）</h3>
              <p className="text-gray-300 mb-4">決済処理はStripe社のシステムを利用しており、Stripe社のプライバシーポリシーが適用されます。</p>

              <h3 className="text-lg font-semibold mb-2 text-gray-200">8.3 グッズ製造・配送（Printful）</h3>
              <p className="text-gray-300">グッズの製造・配送に関しては、Printful社のプライバシーポリシーも適用されます。</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">9. 個人情報の保存期間</h2>
              <p className="text-gray-300">
                当社は、利用目的の達成に必要な期間に限り個人情報を保存し、不要となった場合は速やかに削除します。ただし、法令により保存が義務付けられている場合はこの限りではありません。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">10. 個人情報の開示・訂正・削除</h2>
              <p className="text-gray-300">
                ユーザーは、当社が保有する自己の個人情報について、開示、訂正、削除を請求する権利を有します。請求の際は、本人確認を行った上で、合理的な期間内に対応いたします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">11. 未成年者の個人情報</h2>
              <p className="text-gray-300">
                18歳未満の方が本サービスを利用する場合は、保護者の同意を得た上でご利用ください。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">12. プライバシーポリシーの変更</h2>
              <p className="text-gray-300">
                当社は、必要に応じて本プライバシーポリシーを変更することがあります。重要な変更がある場合は、本サービス上でお知らせします。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">13. お問い合わせ</h2>
              <p className="mb-3 text-gray-300">個人情報の取扱いに関するお問い合わせは、以下までご連絡ください：</p>
              <ul className="list-disc list-inside space-y-1 text-gray-300">
                <li>サービス名：AISHA</li>
                <li>メール：info@mygarage.jp</li>
                <li>運営会社：株式会社ツクルマ</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-100">附則</h2>
              <ul className="list-disc list-inside space-y-1 text-gray-300">
                <li>制定日：2025年1月27日</li>
                <li>最終改定日：2025年1月27日</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyView;